module.exports = __webpack_public_path__ + "img/unit3.bf4509be.png";